import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Item from './Item';
import './styles.css';

class BusinessPlanSectionMenuLayout extends Component {
	render() {
		const { items } = this.props;
		return (
			<div className="business-plan-section-menu-layout">
				{items.map(item => <Item item={item} key={item.to} />)}
			</div>
		);
	}
}

BusinessPlanSectionMenuLayout.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			to: PropTypes.string,
			label: PropTypes.string
		})
	)
};

export default BusinessPlanSectionMenuLayout;
